export const India = "₹"
export const USA = "$"

const getCurrencySymbol = country => {
  switch (country) {
    case "India":
      return India
    case "USA":
      return USA
    default:
      return India
  }
}

export default getCurrencySymbol
